import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { NegotiationListPage } from '@/areas/negotiations/Negotiations/NegotiationListPage/NegotiationListPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/negotiations/')({
    // The navbar hides the entry in production without the source-to-contract add-on. The pages stay open, as the
    // Insights agent links into them.
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <NegotiationListPage />;
}
